export default __webpack_public_path__ + "static/media/ubicacion-usuario.29e86897.svg";